import { actionConst } from '../constants/service.constants';

const defaultState = {
	serviceModalVisible: false,
	setServiceRequestID: undefined,	
	request: undefined,
	parentService: undefined,
	parentServiceId: undefined,
	serviceId: undefined,
	services: [],
}

export default (state = defaultState, action = {}) => {
	switch (action.type) {
		case actionConst.SHOW_SERVICE_OK: {
			return {
				...state,
				setServiceRequestID: action.payload,
			}
		}
		case actionConst.HIDE_SERVICE_OK: {
			return {
				...state,
				setServiceRequestID: undefined
			}
		}
		case actionConst.OPEN_SERVICE_MODAL: {
			return {
				...state,
				request: action.payload.r,
				parentService: action.payload.ps,
				parentServiceId: action.payload.psid,
				serviceId: action.payload.sid,
				services: action.payload.services,
				serviceModalVisible: true,
			}
		}
		case actionConst.CLOSE_SERVICE_MODAL: {
			return {
				...state,
				serviceModalVisible: false
			}
		}
		default:
			return state;
	}
}